"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var planeditor_1 = require("../planeditor");
var ComboEditor = (function () {
    function ComboEditor() {
    }
    ComboEditor.prototype.generateCombo = function (column, value, font, smallFont, colWidth, setNewValueAccordingToGrid, thisCaller) {
        this._caller = thisCaller;
        this._display = column.editor.config.display;
        this._list = column.editor.config.list;
        this.fillListWithColumnValues(column);
        this._keyValuePairs = new Array();
        this.generateKeyValuePairs(value);
        this.setDefaultValue(column, value);
        this.generateZebraList(font);
        this._setNewValueToGrid = setNewValueAccordingToGrid;
        this.createCombo(column, colWidth, value, smallFont);
    };
    Object.defineProperty(ComboEditor.prototype, "combo", {
        get: function () {
            return this._combo;
        },
        enumerable: true,
        configurable: true
    });
    ComboEditor.prototype.fillListWithColumnValues = function (column) {
        if (column.editor.getValues) {
            this._list = column.editor.getValues();
            this.removeUndefinedItemsFromList();
        }
    };
    ComboEditor.prototype.removeUndefinedItemsFromList = function () {
        this._list = this._list.filter(function (item) { return item !== undefined; });
    };
    ComboEditor.prototype.setDefaultValue = function (column, value) {
        if (!value || value === configuration_1.PlanConfiguration.ERROR_STRING) {
            if (_.get(column, "editor.config.defaultValue")) {
                this._currentValue = column.editor.config.defaultValue;
            }
        }
        if (!this._currentValue && value !== undefined) {
            this._currentValue = { key: value, value: value };
        }
        return value;
    };
    ComboEditor.prototype.generateKeyValuePairs = function (value) {
        this.displayObjectToKeyValuePairs(value);
        this.listToKeyValuePairs(value);
        this.removeEmptyEntriesFromKeyValuePairs();
    };
    ComboEditor.prototype.displayObjectToKeyValuePairs = function (value) {
        if (!this._display) {
            return;
        }
        for (var key in this._display) {
            if (this._display.hasOwnProperty(key)) {
                var theItem = { key: key, value: this._display[key] };
                if (value && value.toString() === key.toString()) {
                    this._currentValue = theItem;
                }
                this._keyValuePairs.push(theItem);
            }
        }
    };
    ComboEditor.prototype.listToKeyValuePairs = function (value) {
        var _this = this;
        if (!this._list) {
            return;
        }
        this._list.forEach(function (item) {
            if (value.toString() === item.toString()) {
                _this._currentValue = { key: item.toString(), value: item };
            }
            _this._keyValuePairs.push({ key: item.toString(), value: item });
        });
    };
    ComboEditor.prototype.removeEmptyEntriesFromKeyValuePairs = function () {
        this._keyValuePairs = _.filter(this._keyValuePairs, function (candidate) {
            return candidate.key !== "" && candidate.value !== "";
        });
    };
    ComboEditor.prototype.generateZebraList = function (font) {
        this._valueList = new zebra.ui.List(this._keyValuePairs.map(function (item) { return item.value; }));
        this.formatValueList(font);
    };
    ComboEditor.isEditableDropDown = function (column) {
        return _.get(column, "editor.isEditableDropDown") === true;
    };
    ComboEditor.prototype.createCombo = function (column, colWidth, value, smallFont) {
        this.makeComboObject(column);
        this.formatCombo(colWidth);
        this.formatComboTextField(column, value, smallFont);
        this.setComboBindings(column);
    };
    ComboEditor.prototype.makeComboObject = function (column) {
        var isEditableDropdown = ComboEditor.isEditableDropDown(column);
        this._combo = isEditableDropdown
            ? new zebra.ui.Combo(isEditableDropdown)
            : new this._caller.$clazz.Combo(isEditableDropdown);
    };
    ComboEditor.prototype.formatValueList = function (font) {
        this._valueList["provider"]["text"]["font"] = font;
        this._valueList["provider"]["text"]["color"] = configuration_1.PlanConfiguration.tableColor;
    };
    ComboEditor.prototype.formatCombo = function (colWidth) {
        if (ComboEditor.isActive()) {
            this._combo.setList(this._valueList);
            this._combo.setPreferredSize(configuration_1.PlanConfiguration.comboWidth, -1);
            this._combo.setBackground(configuration_1.PlanConfiguration.comboBackground);
            this._combo.setBorder(new zebra.ui.Border(configuration_1.PlanConfiguration.borderColor, 0));
            this._combo.button.setPreferredSize(configuration_1.PlanConfiguration.comboButtonSize, configuration_1.PlanConfiguration.comboButtonSize);
            var width = colWidth;
            this._combo.setPreferredSize(width, -1);
        }
        this._combo.setVisible(ComboEditor.isActive());
        this.disableComboButtonOnEmptyList();
    };
    ComboEditor.prototype.disableComboButtonOnEmptyList = function () {
        this._combo.button.setEnabled(this._keyValuePairs.length > 0);
    };
    ComboEditor.isActive = function () {
        return true;
    };
    ComboEditor.prototype.formatComboTextField = function (column, value, smallFont) {
        if (ComboEditor.isEditableDropDown(column)) {
            var theTextField = this.getTextField();
            theTextField.setFont(smallFont);
            theTextField.setColor(configuration_1.PlanConfiguration.textColor);
            theTextField.setSelectionColor(configuration_1.PlanConfiguration.textFieldSelectionColor);
            theTextField.setValue(value.toString());
            theTextField.setPadding(1, theTextField.getLeft(), theTextField.getBottom(), theTextField.getRight());
            theTextField.requestFocusIn(1);
        }
    };
    ComboEditor.prototype.getTextField = function () {
        return this._combo.content["textField"];
    };
    ComboEditor.prototype.setComboBindings = function (column) {
        var _this = this;
        this._combo.bind(function (combo, oldValue) {
            if (ComboEditor.isEditableDropDown(column)) {
                _this.applyTextFieldHandler(column);
            }
            else {
                _this.applyCompoDropDownHandler(column);
            }
        });
    };
    ComboEditor.prototype.applyTextFieldHandler = function (column) {
        var _this = this;
        var textField = this.getTextField();
        textField.focusLost = (function (e) {
            var newValue = textField.getValue();
            if (column.dataType === planeditor_1.DATA_TYPES.NUMBER) {
                var base = 10;
                newValue = parseInt(textField.getValue(), base);
            }
            if (_.isFinite(newValue) || column.dataType !== planeditor_1.DATA_TYPES.NUMBER) {
                if (column.editor.addValue) {
                    column.editor.addValue(newValue);
                }
                _this._setNewValueToGrid(newValue);
            }
        });
    };
    ComboEditor.prototype.applyCompoDropDownHandler = function (column) {
        var theComboValue = this._combo.list.getSelected();
        var newValue = _.get(column, "editor.config.display") !== undefined ?
            _.findKey(column.editor.config.display, function (val) { return val === theComboValue; }) :
            theComboValue;
        if (!_.get(column, "editor.config.display") && column.key === "POSTER_SPOTLENGTH") {
            var newItem = _.find(this._keyValuePairs, function (item) {
                return item.value === theComboValue;
            });
            newValue = newItem.value;
        }
        this._setNewValueToGrid(newValue);
    };
    return ComboEditor;
}());
exports.ComboEditor = ComboEditor;
//# sourceMappingURL=comboEditor.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/cellProvider/comboEditor.js
// module id = 16
// module chunks = 0